"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsiveGrid = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const components_1 = require("..");
/** Helper component for generating a responsive grid */
function ResponsiveGrid(props) {
    const { children, ...hookProps } = props;
    const { gridStyles } = (0, components_1.useResponsiveGrid)(hookProps);
    return (0, jsx_runtime_1.jsx)("div", { css: { ...gridStyles }, children: children });
}
exports.ResponsiveGrid = ResponsiveGrid;
